import { createFileRoute } from '@tanstack/react-router';
import { ParaguayFiscalAdminPage } from '@/components/ParaguayFiscalAdminPage';
import { EntitlementGate } from '@/components/primitives/EntitlementGate';
import { useFeatureFlag } from '@/hooks/useFeatureFlags';

export const Route = createFileRoute('/_authenticated/paraguay/')({
  component: ParaguayRoute,
});

function ParaguayRoute(): JSX.Element {
  const enabled = useFeatureFlag('dnit-paraguay', false);

  return (
    <EntitlementGate
      allowed={enabled}
      reason="plan"
      title="DNIT Paraguay está en preparación"
      description="Este producto todavía no está activo para cuentas ni productos actuales. Cuando esté listo, se habilita por feature flag."
    >
      <ParaguayFiscalAdminPage />
    </EntitlementGate>
  );
}
